import { render, staticRenderFns } from "./CenterOfMassMotionViz.vue?vue&type=template&id=41800aca&scoped=true"
import script from "./CenterOfMassMotionViz.vue?vue&type=script&lang=js"
export * from "./CenterOfMassMotionViz.vue?vue&type=script&lang=js"
import style0 from "./CenterOfMassMotionViz.vue?vue&type=style&index=0&id=41800aca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41800aca",
  null
  
)

export default component.exports